import { isAdminConnection, isClientConnection } from "../connection";
import { ClientFirestoreAdapter, AdminFirestoreAdapter } from "./adapter";
/**
 * Type-guard for distinguishing ClientFirestoreAdapter
 */
export function isClientFirestoreAdapter(adapter) {
    return isClientConnection(adapter.underlyingConnection());
}
/**
 * Type-guard for distinguishing AdminFirestoreAdapter
 */
export function isAdminFirestoreAdapter(adapter) {
    return isAdminConnection(adapter.underlyingConnection());
}
/**
 * Wraps the given connection in the correct adapter implementation for its type
 */
export function adapterForConnection(connection, metadataGenerator, converters, logger) {
    if (isClientConnection(connection)) {
        return new ClientFirestoreAdapter(connection, metadataGenerator, converters, logger);
    }
    if (isAdminConnection(connection)) {
        return new AdminFirestoreAdapter(connection, metadataGenerator, converters, logger);
    }
    throw new Error("Unknown connection type");
}
//# sourceMappingURL=guards.js.map